
    import './styles.scoped.css';
    export default {
  "code-editor-refresh": "awsui_code-editor-refresh_1gl9c_1t3u1_98",
  "code-editor": "awsui_code-editor_1gl9c_1t3u1_98",
  "pane": "awsui_pane_1gl9c_1t3u1_438",
  "pane__close-container": "awsui_pane__close-container_1gl9c_1t3u1_449",
  "pane__list": "awsui_pane__list_1gl9c_1t3u1_454",
  "pane__table": "awsui_pane__table_1gl9c_1t3u1_461",
  "pane__item": "awsui_pane__item_1gl9c_1t3u1_466",
  "pane__cell": "awsui_pane__cell_1gl9c_1t3u1_466",
  "pane__item--highlighted": "awsui_pane__item--highlighted_1gl9c_1t3u1_480",
  "pane__location": "awsui_pane__location_1gl9c_1t3u1_501",
  "pane__description": "awsui_pane__description_1gl9c_1t3u1_501",
  "focus-lock": "awsui_focus-lock_1gl9c_1t3u1_516",
  "editor": "awsui_editor_1gl9c_1t3u1_541",
  "editor-refresh": "awsui_editor-refresh_1gl9c_1t3u1_569",
  "status-bar": "awsui_status-bar_1gl9c_1t3u1_574",
  "status-bar-with-hidden-pane": "awsui_status-bar-with-hidden-pane_1gl9c_1t3u1_583",
  "status-bar__left": "awsui_status-bar__left_1gl9c_1t3u1_587",
  "status-bar__left-virtual": "awsui_status-bar__left-virtual_1gl9c_1t3u1_594",
  "status-bar__right": "awsui_status-bar__right_1gl9c_1t3u1_598",
  "status-bar__language-mode": "awsui_status-bar__language-mode_1gl9c_1t3u1_602",
  "status-bar__cursor-position": "awsui_status-bar__cursor-position_1gl9c_1t3u1_602",
  "status-bar__cog-button": "awsui_status-bar__cog-button_1gl9c_1t3u1_607",
  "status-bar-virtual": "awsui_status-bar-virtual_1gl9c_1t3u1_611",
  "tab-button": "awsui_tab-button_1gl9c_1t3u1_617",
  "tab-button--refresh": "awsui_tab-button--refresh_1gl9c_1t3u1_630",
  "tab-button--active": "awsui_tab-button--active_1gl9c_1t3u1_644",
  "tab-button--disabled": "awsui_tab-button--disabled_1gl9c_1t3u1_664",
  "tab-button--divider": "awsui_tab-button--divider_1gl9c_1t3u1_694",
  "tab-button--errors": "awsui_tab-button--errors_1gl9c_1t3u1_701",
  "tab-button--warnings": "awsui_tab-button--warnings_1gl9c_1t3u1_701",
  "loading-screen": "awsui_loading-screen_1gl9c_1t3u1_705",
  "error-screen": "awsui_error-screen_1gl9c_1t3u1_706"
};
  